import { Tooltip } from '@creditsights/styleguide-web';
import { ReactElement } from 'react';
import { ISO3_TO_ISO2_MAP } from './CountryFlag.logic';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function CountryFlag({ countryName, iso3Code }): ReactElement | null {
  const iso2Code = ISO3_TO_ISO2_MAP[iso3Code?.toUpperCase()];

  if (!iso2Code) {
    return null;
  }

  return (
    <Tooltip content={countryName}>
      <span className={`fi fi-${iso2Code.toLowerCase()}`} />
    </Tooltip>
  );
}

export default CountryFlag;
